import { Theme } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1.5),
    margin: theme.spacing(-4, -5, 4, -5),
    backgroundColor: theme.palette.backgroundV2.tertiary,
    height: theme.spacing(4),
    alignItems: 'center',
    padding: theme.spacing(0, 5),
  },
  pendingText: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    color: theme.palette.labraText.tertiary,
  },
  divider: {
    backgroundColor: `${theme.palette.labraText.tertiary} !important`,
    opacity: '24%',
  },
}))
